import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { Thumbnail } from 'src/app/interfaces/thumbnails.interface';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AulaOnlineService {
  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  getAll(): Observable<any> {
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.buscarTodos}`, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao obter as aulas', []))
      );
  }

  getPorCurso(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('cursoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.buscarPorCurso}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a aula', []))
      );
  }

  getMateriasPorAulaId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('aulaOnlineId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.buscarMaterias}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter as matérias', []))
      );
  }

  getPorId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('aulaOnlineId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.buscarPorId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a aula', []))
      );
  }
  
  minhasAulasOnline(id): Observable<any> {
    this.animationsService.showProgressBar(true);    
    const params: HttpParams = new HttpParams().set('materiaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.minhasAulasOnline}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter as aulas', []))
      );
  }

  minhaVideoAulaOnline(id): Observable<any> {
    this.animationsService.showProgressBar(true);    
    const params: HttpParams = new HttpParams().set('aulaOnLineId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.videoAula.videoId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter as aulas', []))
      );
  }

  meusExercicios(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('videoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.meusExercicios}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter os exercicios', []))
      );
  }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.aulaOnline.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }

  deletarPorId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('cursoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.aulaOnline.deletar}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao excluir a aula', []))
      );
  }
  
  getMateriasPorCurso(id): Observable<any> {
    
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('cursoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.materiaOnline.BuscarMateriasPorCurso}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a aula', []))
      );
  }

  getMateriasPorCursoMA(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('cursoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.materiaOnline.BuscarMateriasPorCursoMinhasAulas}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a aula', []))
      );
  }

  getMateriasPorCursoMS(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('cursoId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.materiaOnline.BuscarMateriasPorCursoMeusSimulados}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter a aula', []))
      );
  }

  getVideoAoViveo(): Observable<Thumbnail[]> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.get<Thumbnail[]>(`${environment.baseUrl}${API.videoAula.aoVivo}`, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter o serviço', []))
      );
  }

  getVideoDicasDeEstudo(): Observable<Thumbnail[]> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.get<Thumbnail[]>(`${environment.baseUrl}${API.videoAula.dicasDeEstudo}`, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter o serviço', []))
      );
  }

}
